import React from 'react';

const withLocaleAwareIframe = BaseComponent =>
  class WithLocaleAwareIframe extends React.Component {
    constructor(props) {
      super(props);
      this.setRef = this.setRef.bind(this);
    }

    componentDidMount() {
      this.locale = window.merchantos?.locale;
      if (this.locale) {
        this.iframeEl = this.el.getElementsByTagName('iframe')[0];
        this.iframeEl.addEventListener('load', this.setLocale);
      }
    }

    componentWillUnmount() {
      this.iframeEl = this.el.getElementsByTagName('iframe')[0];
      this.iframeEl.removeEventListener('load', this.setLocale);
    }

    setRef(el) {
      this.el = el;
    }

    setLocale = () => {
      const message = {
        type: 'setLocale',
        payload: { locale: this.locale },
      };
      this.iframeEl.contentWindow.postMessage(message, '*');
    };

    render() {
      return (
        <div ref={this.setRef} style={{ width: '100%', height: '100%' }}>
          <BaseComponent {...this.props} />
        </div>
      );
    }
  };

export default withLocaleAwareIframe;
